import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    job: PropTypes.shape({
      title: PropTypes.string,
    }),
  })
);
